interface MenuDropdownProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const MenuDropdown = ({ children, ...props }: MenuDropdownProps) => {
  return (
    <div
      className={`flex flex-col rounded-[12px] bg-background-elevated shadow-[0_0_10px_0_rgba(0,0,0,0.04)] py-[12px] ${props.className}`}
    >
      {children}
    </div>
  );
};

interface MenuDropdownItemProps extends React.HTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  isActive?: boolean;
}

const MenuDropdownItem = ({ children, className, isActive, ...props }: MenuDropdownItemProps) => {
  return (
    <button
      className={`px-[24px] py-[8px] text-[14px] h-[33px] text-center ${isActive ? 'text-text-main-lv1 font-semibold' : 'text-text-main-lv4 font-medium'} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export { MenuDropdown, MenuDropdownItem };
